import React from 'react'
import PropTypes from 'prop-types'
import AddUserForm from './components/AddUserForm'
import { Link } from 'react-router-dom'
import { Button, Breadcrumb } from 'element-react'
import { MainSection, Section } from '../../components/views/includes/Wrappers'
import Spacer from '../../components/views/includes/Spacer'
import AddMultipleUsers from './components/AddMultipleUsers'
import AppRoutes from '../../routes/appRoutes'

const AddUserPage = props => {
    const { history } = props

    const goBack = () => {
        history.goBack()
    }

    return (
        <MainSection className="admin--add-user">
            <div className="row">
                <div className="columns medium-9">
                    <Breadcrumb separator="/" className="margin-top-small">
                        <Breadcrumb.Item>
                            <Link to={AppRoutes.home()}>Home</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>Add User</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div className="columns medium-3 show-for-medium">
                    <Button
                        type="text"
                        onClick={goBack}
                        className="button-back margin-top-small"
                    >
                        <i className="icon-chevron-thin-left"></i> Go Back
                    </Button>
                </div>
            </div>

            <Section>
                <Spacer size="small" />
                <AddUserForm />
                <Spacer size="medium" />
                <AddMultipleUsers />
                <Spacer size="large" />
            </Section>
        </MainSection>
    )
}

AddUserPage.propTypes = {
    history: PropTypes.shape({
        goBack: PropTypes.func,
    }),
}

export default AddUserPage
